import { Icon } from '../icon';
import { ItemLabel, MenuItemRoot } from '../dropdown/Menu.styled';
import { ButtonProps, LinkButtonProps } from '../button';
import { DropdownSize } from '../dropdown/DropdownSize';

type MenuItemProps = (LinkButtonProps | ButtonProps) & { $size?: DropdownSize }

function isLink(item: MenuItemProps): item is LinkButtonProps {
	return (item as LinkButtonProps).href !== undefined;
}

export function DropdownToggleMenuItem(props: MenuItemProps) {
	const { icon, disabled, label, onClick } = props;
	const danger = props.variant === 'danger';
	return <MenuItemRoot
		{...props}
		$disabled={disabled}
		as={isLink(props) ? 'a' : 'button'}
		{...(!disabled && onClick)}
		role={'menuitem'}
		$danger={danger}
		// What the sliding hover rectangle tracks. See Menu.
		data-value={label}
		data-disabled={disabled || undefined}
	>
		{icon && <Icon icon={icon} />}
		<ItemLabel $danger={danger} $disabled={disabled}>{label}</ItemLabel>
	</MenuItemRoot>;
}
